export default __webpack_public_path__ + "static/media/blueAvtarLogo.ca1b7bf1.svg";